import {getAddressOptions, injectAddressFieldsIntoSchema} from 'utils/addressSchemaUtils';

const getSchema = (schema, addresses = []) => {
  const addressOptions = getAddressOptions(addresses);

  const processedSchema = injectAddressFieldsIntoSchema(schema, addressOptions, {
    selectorField: 'addressSelector',
    defaultValue: 'new_address',
  });

  return processedSchema;
};

export {getSchema};
